import TimeSelectInput from "./TimeSelectInput";
import { changeForm } from "../searchFlightsSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { TimeSelect } from "../../../types";
import { convertTimeSelect } from "../utils";
import { useTranslation } from "react-i18next";

function ReturningTimeInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const returningTime = useAppSelector(
    (state) => state.searchFlights.form.returningTimeSelect
  );
  const roundTrip = useAppSelector(
    (state) => state.searchFlights.form.roundTrip
  );

  const onSelect = (time: TimeSelect) => {
    dispatch(
      changeForm({
        returningTime: convertTimeSelect(time),
        returningTimeSelect: time,
      })
    );
  };

  return (
    <TimeSelectInput
      id="return-time-input"
      value={returningTime}
      disabled={!roundTrip}
      label={t("RETURN_TIME")}
      onSelect={onSelect}
      noTime={false}
    />
  );
}

export default ReturningTimeInput;
